module.exports = __webpack_public_path__ + "static/media/evan-head.fa440bd6.png";